<template>
  <div>
    <v-sheet
      :min-height="$vuetify.breakpoint.lgAndDown ? 'auto' : '145'"
      :height="$vuetify.breakpoint.lgAndDown ? 'auto' : '145'"
      class="invoicingReportFilter">
      <v-container
        fluid
        :class="{
          'fill-height': true,
          'py-6': $vuetify.breakpoint.mdAndDown,
        }">
        <v-row
          :class="{
            'fill-height': true,
            'd-flex justify-center': $vuetify.breakpoint.mdAndDown,
          }">
          <v-col
            md="4"
            sm="12"
            :class="colFilter.class"
            :style="$vuetify.breakpoint.lgAndUp ? colFilter.style : ''">
            <Autocomplete
              label="Grupo Financeiro"
              placeholder="Selecione"
              v-model="filterMyReports.financialGroupId"
              :items="financialGroups"
              :search-input.sync="financialGroupIdSearch"
              @change="financialGroupIdSearch = null"
              item-text="name"
              item-value="id"
              hide-details
              regular
              color="primary"
              item-color="primary"
            />
          </v-col>

          <v-col
            md="4"
            sm="12"
            :class="colFilter.class"
            :style="$vuetify.breakpoint.lgAndUp ? colFilter.style : ''">
            <Autocomplete
              label="Status"
              placeholder="Selecione"
              v-model="filterMyReports.status"
              :items="myReportsStatusFilter"
              :search-input.sync="statusSearch"
              @change="statusSearch = null"
              item-text="name"
              item-value="id"
              hide-details
              regular
              color="primary"
              item-color="primary"
            />
          </v-col>

          <v-col
            md="4"
            sm="12"
            :class="colFilter.class"
            :style="$vuetify.breakpoint.lgAndUp ? colFilter.style : ''">
            <Select
              label="Período"
              v-model="selectedDate"
              :items="dateList"
              hide-details
              regular
            />
          </v-col>

          <v-col
            md="6"
            sm="12"
            :class="colFilter.class"
            :style="colFilter.style"
            v-if="selectedDate === 'custom' && $vuetify.breakpoint.mdAndDown">
            <v-menu
              v-if="selectedDate === 'custom'"
              max-width="350px"
              v-model="menu"
              ref="menu"
              transition="scale-transition"
              offset-y
              :close-on-content-click="false"
              :return-value.sync="dates">
              <template v-slot:activator="{ on, attrs }">
                <Textfield
                  label="Datas"
                  v-model="dateRangeText"
                  readonly
                  regular
                  hide-details
                  v-bind="attrs"
                  v-on="on"
                />
              </template>

              <v-date-picker
                width="auto"
                range
                v-model="dates"
                no-title
                color="primary"
                :allowed-dates="allowedDates">
                <v-row class="mx-2">
                  <v-col
                    cols="12"
                    align="end">
                    <v-btn
                      text
                      color="primary"
                      @click="menu = false">
                      Cancelar
                    </v-btn>

                    <v-btn
                      class="white--text"
                      color="primary"
                      @click="handlerDate(dates)">
                      OK
                    </v-btn>
                  </v-col>
                </v-row>
              </v-date-picker>
            </v-menu>
          </v-col>

          <v-col
            cols="12"
            xl="3"
            lg="3"
            md="12"
            :class="{
              'd-flex align-center gap-h-20': true,
              'justify-center': $vuetify.breakpoint.mdAndDown || $vuetify.breakpoint.xl,
              'justify-start': $vuetify.breakpoint.lg,
              'flex-column gap-v-20': $vuetify.breakpoint.xs,
            }">
            <v-btn
              class="white--text"
              color="primary"
              :style="btnFilter.style"
              @click="handlerFilter()">
              Pesquisar
            </v-btn>

            <v-btn
              class="primary--text"
              color="matte"
              :style="btnFilter.style"
              @click="cleanFilter()">
              Limpar Filtros
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>

    <SnackbarCustomize ref="SnackbarCustomize" />
  </div>
</template>

<script>
import DatePickerCustom from "@/components/DashboardMovementRecords/Common/DatePickerCustom.vue";
import SnackbarCustomize from '@/components/CustomAlerts/SnackbarCustomize.vue';
import Autocomplete from '../Autocomplete.vue';
import Textfield from '../Textfield.vue';
import Select from '../Select.vue';

import MovementRecordsMixin from "@/shared/mixins/movementRecords/movementRecordsMixin";
import MyReportsMixin from "@/shared/mixins/myReports/myReportsMixin";
import InvoicingMixin from '@/shared/mixins/invoicing/invoicingMixin';
import moment from 'moment';
import { mapGetters } from 'vuex';

export default {
	name: "ReportFilter",

  components: {
    SnackbarCustomize,
    DatePickerCustom,
    Autocomplete,
    Textfield,
    Select,
  },

	data: () => ({
    menu: false,
    selectedDate: 'lastThirtyDays',
    dates: [],
    dateList: [
      {
        text: 'Últimos 7 dias',
        value: 'lastSevenDays',
        disabled: false,
      },
      {
        text: 'Últimos 30 dias',
        value: 'lastThirtyDays',
        disabled: false,
      },
      {
        text: 'Últimos 3 meses',
        value: 'lastThreeMonths',
        disabled: false,
      },
      {
        text: 'Mês Atual',
        value: 'currentMonth',
        disabled: false,
      },
      {
        text: 'Personalizado',
        value: 'custom',
        disabled: false,
      },
      {
        text: 'Nenhuma Seleção de Data',
        value: 'noDate',
        disabled: false,
      },
      {
        text: 'Personalizado',
        value: 'custom',
        disabled: false,
      },
    ],

		financialGroupIdSearch: null,
    statusSearch: null,
		reportLayoutSearch: null,
	}),

	mixins: [
    InvoicingMixin,
    MovementRecordsMixin,
    MyReportsMixin
  ],

  props: {
		resetFilterMyReports: {
			type: Boolean,
			default: false
		},
	},

  watch: {
		filterMyReports: {
			deep: true,
			immediate: true,
			handler(value) {
				if (value) this.$emit("hasFiltersMyReports", this.filterMyReports);
			}
		},
		resetFilterMyReports: {
			deep: true,
			handler(value) {
				if (value) this.clearFilterMyReports()
			}
		},
    selectedDate: {
      handler() {
        this.setDateFilter(this.selectedDate);

        this.$emit('updateDates', this.dates);
      }
    }
	},

	methods: {
    handlerFilter() {
      if (this.selectedDate === 'noDate') {
        if (!this.filterMyReports.financialGroupId || this.filterMyReports.status) {
          this.dates = [];
          this.$refs.SnackbarCustomize.open('error', 'Preencha um campo');
          return;
        }
      }

      this.setDateFilter(this.selectedDate)

      this.$emit('handlerClickFilter', this.dates);
    },

    setDateFilter(value) {
      const today = moment();
      const dateRanges = {
        lastSevenDays: 6,
        lastThirtyDays: 29,
        lastThreeMonths: 89,
        currentMonth: today.clone().startOf('day').diff(today.clone().startOf('month').startOf('day'), 'days'),
        noDate: 'noDate',
      };

      let startDate;
      if (value === 'noDate') {
        this.dates = [];
        startDate = [];
      } else if (dateRanges[value] !== undefined) {
        startDate = today.clone().subtract(dateRanges[value], 'days');
        this.dates = [startDate.format('YYYY-MM-DD'), today.format('YYYY-MM-DD')];
      }
    },

    cleanFilter() {
      this.selectedDate = 'lastThirtyDays';
      this.dates = [];
      this.$emit('clearFilters');
    },

    clearFilterMyReports() {
			this.filterMyReports = {
				financialGroupId: '',
				reportLayout: '',
				status: '',
				receivingDateStart: '',
				receivingDateEnd: '',
			}
			this.$forceUpdate()
			this.$emit("resetStatusFilters", false)
		},

    handlerDate(dates) {
      this.menu = false;
      const dateFormated = dates;

      if (dateFormated[0] > dateFormated[1]) {
        [dateFormated[0], dateFormated[1]] = [dateFormated[1], dateFormated[0]];
      }

      this.$refs.menu.save(dateFormated);
    },

    allowedDates(date) {
      const selectedDate = moment(date);

      if (
        typeof this.dates === 'undefined' ||
        this.dates === null
      ) {
        this.dates = [];
      }

      if (this.dates.length === 0) {
        return true;
      }

      const startDate = moment(this.dates[0]);
      const minDate = startDate.clone().subtract(365, 'days');
      const currentDate = moment();

      return (
        selectedDate.isBetween(minDate, startDate.add(365, 'days'), 'day', '[]')
        && selectedDate.isSameOrBefore(currentDate, 'day')
      );
    },
	},

  computed: {
    ...mapGetters({
      financialGroups: 'financial-group/groups',
      isRHProtegido: 'user-info/isRHProtegido',
    }),

    dateRangeText() {
      let text = '-';
      if (this.dates && this.dates.length > 0) {
        const sortedDates = this.dates.slice().sort((a, b) => new Date(a) - new Date(b));

        const formattedStartDate = moment(sortedDates[0]).format('DD/MM/YYYY');
        const formattedEndDate = moment(sortedDates[1]).format('DD/MM/YYYY');
        text = `${formattedStartDate} ~ ${formattedEndDate}`;
      }

      return text;
    },
  },

  mounted() {
    this.handlerFilter();
  },
}
</script>


<style>
.invoicingReportFilter {
  border-radius: 5px !important;
  box-shadow: 0px 3px 6px #00000029 !important;
}
</style>